var React = require('react');

function HeartFilledInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.44 0C12.63 0 11.01 0.88 10 2.23C8.99 0.88 7.37 0 5.56 0C2.49 0 0 2.5 0 5.59C0 6.78 0.19 7.88004 0.52 8.90004C2.1 13.9 6.97 16.89 9.38 17.71C9.72 17.83 10.28 17.83 10.62 17.71C13.03 16.89 17.9 13.9 19.48 8.90004C19.81 7.88004 20 6.78 20 5.59C20 2.5 17.51 0 14.44 0Z","fill":"#292D32"}));
}

HeartFilledInline.defaultProps = {"width":"22","height":"20","viewBox":"0 0 20 18","fill":"none"};

module.exports = HeartFilledInline;

HeartFilledInline.default = HeartFilledInline;
